<template>
    <form-row :title="user_is_attorney ? 'Has the buyer received <br>their property disclosures?' : 'Have you received <br>your property disclosures?'">
        <input-radio-boolean
            name="has_received_disclosures"
            :value="attorney.has_received_disclosures"
            true="Yes"
            false="No"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        attorney: {},
        read_only: { default: false },
        user_is_attorney: { default: false },
    },
}
</script>
